<template>
  <v-btn :loading="loading" :disabled="disabled" color="primary" class="ml-3" x-small @click="confirmDownload()">
    {{ this.$t('common.download') }}
    <template v-slot:loader>
      <span class="loader">
        <v-icon small>mdi-cached</v-icon>
      </span>
    </template>
  </v-btn>
</template>

<script>
export default {
  props: {
    loading: Boolean,
    disabled: Boolean,
  },
  methods: {
    // BEGIN::Added.by.KWShin.2026.01.16.
    async confirmDownload() {
      if (await this.$dialog.confirm(this.$t('common.download.q'))) {
        this.$emit('download');
      }
    },
    // FINISH::Added.by.KWShin.2026.01.16.
  },
};
</script>

<style lang="scss" scoped>
.loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
